const additional = function( ) {


    document.querySelectorAll('.block-open-toggle').forEach((toggle) =>  {

      if (!toggle.classList.contains('processed')) {




        toggle.addEventListener('click', () =>  {
          let ref = toggle.dataset.ref_item;
          let item = document.getElementById(ref);
          item.style.display = 'block';
          setTimeout(() => item.classList.add('is-visible'), 0);
        });



        toggle.classList.add('processed');
      }
    });





  document.querySelectorAll('.block-close-toggle').forEach((toggle) =>  {

    if (!toggle.classList.contains('processed')) {




      toggle.addEventListener('click', () =>  {
        let ref = toggle.dataset.ref_item;
        let item = document.getElementById(ref);
        item.classList.remove('is-visible');
        setTimeout(() => item.style.display = 'none', 300);
      });



      toggle.classList.add('processed');
    }
  });

}







export default additional
